<template>
	<div class="qr-code-box">
		<canvas ref="canvas" class="qr-canvas"></canvas>
	</div>
</template>

<script>
	import QRCode from 'qrcode';

	// QR renderer used by the receipt forms and the OCR popup (imported locally where needed).
	// Replaces the old `vue-qrcode-component`; uses the `qrcode` library (same one the cards use),
	// which auto-selects the QR version up to 40 — so long payloads (e.g. a long receipt qr_data)
	// still render instead of throwing "code length overflow" / "clear is not a function".
	// errorCorrectionLevel 'L' maximizes capacity (~2953 bytes); fine here since the QR is only
	// shown on screen (no print damage).
	export default {
		name: 'QrCodeBox',
		props: {
			text: { type: String, required: true },
			size: { type: Number, required: false, default: 200 },
		},
		watch: {
			text() {
				this.render();
			},
		},
		mounted() {
			this.render();
		},
		methods: {
			render() {
				const canvas = this.$refs.canvas;
				if (!canvas || !this.text) {
					return;
				}
				QRCode.toCanvas(canvas, this.text, {
					width: this.size,
					margin: 1,
					errorCorrectionLevel: 'L',
				}).catch((error) => {
					// eslint-disable-next-line no-console
					console.warn('QR render failed:', error && error.message);
				});
			},
		},
	};
</script>

<style scoped>
	.qr-canvas {
		max-width: 100%;
		vertical-align: middle;
		height: auto;
	}
</style>
